import { useEffect } from 'react';

export const SITE_NAME = 'One Stop Greek';

// 'Contact' becomes 'Contact - One Stop Greek'.
export function pageTitle(name) {
  return name ? `${name} - ${SITE_NAME}` : SITE_NAME;
}

// Names the browser tab for the page that calls this hook.
//
// The HTML shell carries one title for the whole site, so without this every
// route reads 'One Stop Greek' and a visitor with several tabs open cannot
// tell them apart.
function usePageTitle(name) {
  useEffect(() => {
    document.title = pageTitle(name);
  }, [name]);
}

export default usePageTitle;
